module.exports = __webpack_public_path__ + "static/media/brand.8a35ad2f.svg";